import React from 'react'

import { useGetROILSummaryQuery } from '../api/for-company/oil.api'
import { selectProjectById } from '../api/for-company/projects.api'
import { ForProjectRole } from '../components/Auth/ForProjectRole'
import { ToolbarActions } from '../components/Drawers/Toolbar'
import { ListROIL } from '../components/OIL/ROIL'
import { StatusesOverview } from '../components/OIL/StatusesOverview'
import { AircraftInformationDrawer } from '../components/Projects/AircraftInformation/AircraftInformationDrawer'
import { ProjectRolePermissions } from '../domain/project-role.domain'
import { routes } from '../routes'
import { useAppSelector } from '../store'

import { Page } from './shared/Page'

const ROILToolbarActions: React.FC<{ projectId: number; subjectId: number }> = props => {
    const { projectId, subjectId } = props
    const { data, isLoading } = useGetROILSummaryQuery({ id: projectId })
    const oilSummary = data?.results.find(s => s.id === subjectId)

    return (
        <ToolbarActions>
            <ForProjectRole permission={ProjectRolePermissions.OILList} projectId={projectId}>
                <StatusesOverview oilSummary={oilSummary} isLoading={isLoading} />
            </ForProjectRole>
            <ForProjectRole
                permission={ProjectRolePermissions.AircraftInformationView}
                projectId={projectId}
            >
                <AircraftInformationDrawer projectId={projectId} />
            </ForProjectRole>
        </ToolbarActions>
    )
}

export const ROILPage: React.FC = () => {
    const { projectId, subjectId } = routes.ROIL.useParams()
    const project = useAppSelector(selectProjectById(projectId))

    if (!project) {
        return null
    }

    return (
        <ForProjectRole permission={ProjectRolePermissions.OILList} projectId={projectId}>
            <Page logo={project.auditorLogo}>
                <ListROIL projectId={projectId} subjectId={subjectId} />
            </Page>
            <ROILToolbarActions projectId={projectId} subjectId={subjectId} />
        </ForProjectRole>
    )
}
